import { jsx } from 'react/jsx-runtime';
import React__default, { useState, useEffect, useCallback, useMemo } from 'react';

const PDFViewControlsContext = /* @__PURE__ */ React__default.createContext({});
const ZOOM = {
  MAX: 3,
  MIN: 0.2
};
const PDFViewControlsContextProvider = ({ children, onZoomLevelChange }) => {
  const [state, setState] = useState({
    zoomLevel: 1,
    disableAnimation: false
  });
  const setZoomLevel = useCallback((value2, options) => {
    setState((prev) => {
      const nextValue = typeof value2 === "function" ? value2(prev.zoomLevel) : options?.increment ? prev.zoomLevel + value2 : value2;
      const nextZoomValue = Math.max(Math.min(nextValue, ZOOM.MAX), ZOOM.MIN);
      if (nextZoomValue === prev.zoomLevel) {
        return prev;
      }
      options?.onSet?.({
        value: nextZoomValue,
        prevValue: prev.zoomLevel
      });
      if (onZoomLevelChange) {
        onZoomLevelChange({
          value: nextZoomValue,
          prevValue: prev.zoomLevel
        });
      }
      return {
        ...prev,
        zoomLevel: nextZoomValue,
        disableAnimation: options?.disableAnimation ?? false
      };
    });
  }, [
    onZoomLevelChange
  ]);
  const value = useMemo(() => ({
    zoomLevel: state.zoomLevel,
    setZoomLevel,
    disableAnimation: state.disableAnimation
  }), [
    state.zoomLevel,
    setZoomLevel,
    state.disableAnimation
  ]);
  return /* @__PURE__ */ jsx(PDFViewControlsContext.Provider, {
    value,
    children
  });
};
const usePDFViewControls = (args) => {
  const context = React__default.useContext(PDFViewControlsContext);
  if (!context) {
    throw new Error("usePDFViewControls must be used within a PDFViewControlsContextProvider");
  }
  const onZoomLevelChange = args?.onZoomLevelChange;
  const zoomLevel = context.zoomLevel;
  const disableAnimation = context.disableAnimation;
  const [_, setPrevZoomLevel] = useState(context.zoomLevel);
  useEffect(() => {
    setPrevZoomLevel((prev) => {
      if (prev === zoomLevel) return prev;
      if (onZoomLevelChange) {
        onZoomLevelChange({
          value: zoomLevel,
          prevValue: prev,
          disableAnimation
        });
      }
      return zoomLevel;
    });
  }, [
    onZoomLevelChange,
    zoomLevel,
    disableAnimation
  ]);
  return context;
};

export { PDFViewControlsContextProvider, usePDFViewControls };
//# sourceMappingURL=PDFViewControls.js.map
